import React, { useEffect, useRef } from "react";
import Point from "../models/Point";

import Logger from "../Logger";
import { GrabMoveHandler } from "./ConnectorGrab";
import WatchableValue from "../models/WatchableValue";
import { noItx } from "../translationItx/itx";

const logger = new Logger();

export default function ResizeGrab(props: {
  side: "top" | "bottom" | "left" | "right"; // no itx
  initialSize: { sx: number; sy: number };
  setSize: (
    side: "top" | "bottom" | "left" | "right", // no itx
    sx: number,
    sy: number,
  ) => void;
  setSizeEnd: () => void;
  selected: boolean;
  currentZoom: WatchableValue<number>;
}) {
  const { side, initialSize, setSize, setSizeEnd, selected, currentZoom } = props;
  const thisElement = useRef<HTMLDivElement>(null);
  const startPoint = useRef(new Point(0, 0));

  const isDown = useRef(false);

  const grabLineWidth = 40;

  let outerStyle: any = {
    // zIndex: "11",
    position: "absolute",
    border: "0px solid red",
    boxSizing: "border-box", // no itx
    pointerEvents: "auto",
  };

  let grabStyle: any = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    color: "orange",
  };

  let rotate90 = "";

  switch (side) {
    case "left": // no itx
    case "right": // no itx
      outerStyle = {
        ...outerStyle,
        height: "100%",
        width: `${grabLineWidth}px`,
        cursor: "w-resize", // no itx
      };

      grabStyle = {
        ...grabStyle,
        height: "100%",
      };

      break;

    case noItx("top"):
    case "bottom":
      rotate90 = "rotate(90deg)"; // no itx

      outerStyle = {
        ...outerStyle,
        left: `0px`,
        width: "100%",
        height: `${grabLineWidth}px`,
        cursor: "ns-resize", // no itx
      };

      grabStyle = {
        ...grabStyle,
        width: "100%",
      };
      break;
  }

  switch (side) {
    case noItx("top"):
      outerStyle = { ...outerStyle, top: `${-grabLineWidth / 2}px` };
      break;
    case "bottom":
      outerStyle = { ...outerStyle, bottom: `${-grabLineWidth / 2}px` };
      break;

    case noItx("left"):
      outerStyle = { ...outerStyle, left: `${-grabLineWidth / 2}px` };
      break;
    case "right":
      outerStyle = { ...outerStyle, right: `${-grabLineWidth / 2}px` };
      break;
  }

  if (!selected) {

  }

  return (
    <div ref={thisElement} style={outerStyle}
      onPointerDown={(event) => {
        if (thisElement.current) {
          event.stopPropagation();
          event.preventDefault();

          isDown.current = true;
          thisElement.current.setPointerCapture(event.pointerId);
          const p = new Point(event.screenX / currentZoom.value, event.screenY / currentZoom.value);

          startPoint.current = p;
        }
      }}

      onPointerUp={(event) => {
        isDown.current = false;
        event.stopPropagation();
        event.preventDefault();

        setSizeEnd();
      }}

      onPointerMove={(event) => {
        if (thisElement.current && event.pointerId && isDown.current) {
          event.stopPropagation();
          event.preventDefault();

          const p = new Point(event.screenX / currentZoom.value, event.screenY / currentZoom.value);
          const f = initialSize.sx / initialSize.sy;

          switch (side) {
            case noItx("top"): {
              const dy = -p.y + startPoint.current.y;
              setSize(side, initialSize.sx, initialSize.sy + dy);
              break;
            }

            case "bottom": {
              const dy = p.y - startPoint.current.y;
              setSize(side, initialSize.sx, initialSize.sy + dy);
              break;
            }

            case noItx("left"): {
              const dx = -p.x + startPoint.current.x;
              setSize(side, initialSize.sx + dx, initialSize.sy);
              break;
            }

            case "right": {
              const dx = p.x - startPoint.current.x;
              setSize(side, initialSize.sx + dx, initialSize.sy);
              break;
            }
          }

          startPoint.current = p;

        }
      }}

    >

      <div style={grabStyle}>
        <div
          style={{
            position: "relative",
            height: "1px",
            width: "1px",
          }}

        >
          {/* <div
            className="grabIcon"
            style={{
              marginLeft: (side == "top" || side == "bottom") ? "-20px" : "0px",
              marginTop: (side == "left" || side == "right") ? "-20px" : "0px",
              transform: (side == "top" || side == "bottom") ? "rotate(90deg)" : "none",

            }}
          >
            <div
              style={{
                position: "absolute",
                left: "3px",
                top: "2px",
                fontSize: "20px",
                whiteSpace: "nowrap",
              }}
            >
              {"< >"}
            </div>
          </div> */}
        </div>
      </div>
    </div>

  );
}
